import "./scss/styles.scss";
import '/node_modules/glightbox/dist/css/glightbox.min.css';
import GLightbox from 'glightbox';
import Splide from '@splidejs/splide';

const initFilter = () => {
  if (document.querySelectorAll('[data-filter]').length > 0) {
    var c = document.querySelectorAll('[data-filter]');
    var total = c.length;
    for (var i=0; i<total; i++) {
      var id = c[i].dataset.filter;
      var q = document.querySelectorAll('[data-filter-item="'+id+'"]');
      doFilter(q,c[i]);
    }
  }
};

const doFilter = (q,c) => {
  c.addEventListener('click', function(event) {
    var isActive = c.classList.contains('active');
    var f = document.querySelectorAll('[data-filter]');
    var total = f.length;
    for (var i=0; i<total; i++) {
      f[i].classList.remove('active');
    }

    var search = c.textContent;
    total = q.length;
    if (isActive) {
      c.classList.remove('active');
      for (var i=0; i<total; i++) {
        q[i].classList.remove('hidden');
      }
    } else {
      c.classList.add('active');
      for (var i=0; i<total; i++) {
        q[i].classList.add('hidden');
        if (q[i].textContent.trim().startsWith(search)) {
          q[i].classList.remove('hidden');
        }
      }
    }
  });
}

const initIframe = () => {
  if (document.querySelectorAll('[data-iframe-container]').length > 0) {
    var c = document.querySelectorAll('[data-iframe-container]');
    var total = c.length;
    for (var i=0; i<total; i++) {
      var el = c[i].querySelector('[data-iframe-button]');
      showIframe(el,c[i]);
    }
  }
};

const showIframe = (el,c) => {
  var show = sessionStorage.getItem("show_iframe");

  el.addEventListener('click', function(event) {
    // check if user wants to save the decision
    var remember = c.querySelector('[data-iframe-button-remember]');
    if (remember.checked) {
      sessionStorage.setItem("show", "true");
    }
    var placeholder = c.querySelector('[data-iframe-placeholder]');
    placeholder.classList.add('hidden');
    var iframe = c.querySelector('[data-iframe-src]');
    iframe.src = iframe.dataset.iframeSrc;
    iframe.classList.remove('hidden');
    event.stopPropagation();
  });

  if (show && show === 'true') {
    var placeholder = c.querySelector('[data-iframe-placeholder]');
    placeholder.classList.add('hidden');
    var iframe = c.querySelector('[data-iframe-src]');
    iframe.src = iframe.dataset.iframeSrc;
    iframe.classList.remove('hidden');
  }
}

(() => {
  document.body.parentNode.classList.add('js');
  document.body.parentNode.classList.remove('no-js');

  // lightbox
  const lightbox = GLightbox();

  // slider
  if (document.querySelector('.splide')) {
    var splide = new Splide('.splide', {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      breakpoints: {
        840: {
          perPage: 3,
        },
        600: {
          perPage: 2,
        },
      }
    });
    splide.mount();
  }

  // iframe
  initIframe();

  // filter
  initFilter();
})();

/*
const modal = document.querySelector('#modal');
const modalTrigger = document.querySelectorAll('[data-modal]');
const modalImage = document.querySelector('#modal-image');
modalTrigger.forEach((el) => {
  el.style.cursor = 'pointer';
  el.addEventListener('click', (event) => {
    event.preventDefault();
    modal.classList.toggle('active');
    modalImage.src=event.target.dataset.modal;
  });
});
const modalClose = document.querySelectorAll('[data-modal-close]');
modalClose.forEach((el) => {
  el.addEventListener('click', (event) => {
    event.preventDefault();
    modal.classList.remove('active');
  });
});
document.addEventListener('keydown', function(event){
	if(event.key === "Escape"){
    event.preventDefault();
    modal.classList.remove('active');
	}
});
*/

/*
const navbars = document.getElementsByClassName('navbar');
const navbar = navbars[0];
const top = getPosition(navbar).top;

checkTopPosition(top);
window.onscroll = function() {
  checkTopPosition(top);
};
const body = document.querySelector('body');
const button = document.querySelector('a[data-navbar-toggle]');
button.addEventListener('click', (e) => {
  e.preventDefault();
  body.classList.toggle('is-navbar-open');
});

function getPosition(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
}

function checkTopPosition(top) {
  var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
  if (scrollTop < top) {
    document.body.setAttribute('data-scrolled','false');
  } else {
    document.body.setAttribute('data-scrolled','true');
  }
}
*/
